/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MfaRegistrationResult
 */
export interface MfaRegistrationResult {
    /**
     * 
     * @type {boolean}
     * @memberof MfaRegistrationResult
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof MfaRegistrationResult
     */
    message?: string;
}

/**
 * Check if a given object implements the MfaRegistrationResult interface.
 */
export function instanceOfMfaRegistrationResult(value: object): value is MfaRegistrationResult {
    if (!('success' in value) || value['success'] === undefined) return false;
    return true;
}

export function MfaRegistrationResultFromJSON(json: any): MfaRegistrationResult {
    return MfaRegistrationResultFromJSONTyped(json, false);
}

export function MfaRegistrationResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): MfaRegistrationResult {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function MfaRegistrationResultToJSON(json: any): MfaRegistrationResult {
    return MfaRegistrationResultToJSONTyped(json, false);
}

export function MfaRegistrationResultToJSONTyped(value?: MfaRegistrationResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
    };
}

